import React from 'react';

import { FormBaseProps } from '../form-input';
import { FormProps, FormComponentProps } from 'antd/lib/form';
import { Upload, Icon, Modal, Form, Input, Button } from 'antd';
import {
    UploadListType,
    UploadFile,
    UploadProps,
    UploadChangeParam,
} from 'antd/lib/upload/interface';
import { PrototypeCheck } from '../utils';
import { WrappedFormUtils } from 'antd/lib/form/Form';

interface IFormUpLoadProps
    extends FormBaseProps,
        FormProps,
        Omit<UploadProps, 'onChange' | 'method'> {
    form: FormComponentProps['form'];
    /** 标准化选择的value使之满足setFieldsValue */
    normalizeValue?: (value: any, option: any, fieldValue: any) => any;
    /** 上传文件类型，img | file */
    fileType: string;
    listType: UploadListType;
    controlNum?: number;
    action: string;
    /** 获取图片路径并回显 */
    getImageUrl: Function;
    /** 预览回调函数 */
    handlePreview?: (file: any) => void;
    /** 是否显示上传进度 */
    showProgress?: boolean;
    /** 个性化显示 */
    customUploadList?: (fieldValue: any) => any;
    /** 处理上传后回调返回当前上传的数据 */
    handleChangeCallBack?: (fileList: any, form: WrappedFormUtils) => any;
    /** 上传按钮显示文本 */
    textForDisplay?: string;
    /** a标签显示文本 */
    textForAnchor?: string;
}

interface IFormUpLoadState {
    previewVisible: boolean;
    previewImage: string;
    fileList: Array<UploadFile>;
    progressPercent?: number;
}
/** 表单上传组件 */
class FormUpload extends React.Component<IFormUpLoadProps, IFormUpLoadState> {
    constructor(props: IFormUpLoadProps) {
        super(props);
        this.state = {
            previewVisible: false,
            previewImage: '',
            fileList: [],
        };
    }

    handleCancel = () => this.setState({ previewVisible: false });

    handlePreview = async (file: any) => {
        if (this.props.handlePreview) {
            return this.props.handlePreview(file);
        }
        if (!file.url && !file.preview) {
            file.preview = await getBase64(file.originFileObj);
        }

        this.setState({
            previewImage: file.url || file.preview,
            previewVisible: true,
        });
    };

    handleChange = (
        info: UploadChangeParam<UploadFile>,
        type: string,
        cb?: Function,
        option?: object
    ) => {
        let { fileList, event } = info;
        const { setFieldsValue, getFieldValue } = this.props.form;
        const { field, normalizeValue, controlNum, showProgress } = this.props;
        if (event && showProgress) {
            this.setState({ progressPercent: Number(event.percent.toFixed(0)) });
        }
        if (type === 'file') {
            fileList = this.handleFileChange(fileList, controlNum);
        }
        const value = normalizeValue
            ? normalizeValue(fileList, option, getFieldValue(field))
            : fileList;
        setFieldsValue({
            [field]: value,
        });
        cb && cb(value, this.props.form);
    };

    handleFileChange = (fileList: any, controlNum?: number) => {
        const cNums = controlNum ? controlNum : 0;
        let negNum: number = 0 - cNums;
        fileList = fileList.slice(negNum);

        fileList = fileList.map((file: any) => {
            if (file.response) {
                file.url = file.response.url;
            }
            return file;
        });

        return fileList;
    };

    getTypedList = (fileList: Array<any>) => {
        let typedList: Array<any> | undefined;

        typedList = PrototypeCheck.isArray(fileList)
            ? fileList.map((item: any) => {
                  let typedListItem = {} as UploadFile;
                  typedListItem = { ...item };
                  typedListItem.url = this.props.getImageUrl(item);
                  typedListItem.name =
                      typedListItem.name || this.props.textForAnchor || typedListItem.url || '';
                  return typedListItem;
              })
            : undefined;

        return typedList;
    };

    renderUploadComponentByFiletype = (type: string, fileList: any, controlNum?: number) => {
        const cNums = controlNum ? controlNum : fileList && fileList.length + 1;

        const { textForDisplay } = this.props;

        const text = textForDisplay ? textForDisplay : '上传';

        const uploadButtonForImage = (
            <div>
                <Icon type="plus" />
                <div className="ant-upload-text">{text}</div>
            </div>
        );

        const uploadButtonForButton = (
            <Button>
                {text}
                <Icon type="upload"></Icon>
            </Button>
        );

        if (type === 'image') {
            if (fileList) {
                return fileList.length >= cNums ? null : uploadButtonForImage;
            }
            return uploadButtonForImage;
        } else if (type === 'file') {
            if (fileList) {
                return fileList.length >= cNums ? null : uploadButtonForButton;
            }
            return uploadButtonForButton;
        }
    };

    onRemove = () => {
        this.setState({ progressPercent: 0 });
    };

    render() {
        const {
            label,
            labelCol,
            wrapperCol,
            field,
            action,
            controlNum,
            listType,
            fileType,
            initialValue,
            required,
            validator,

            customUploadList,
            handleChangeCallBack,
            headers,
            textForAnchor,
            ...restProps
        } = this.props;
        const { getFieldDecorator, getFieldValue } = this.props.form;
        const { previewVisible, previewImage, progressPercent } = this.state;
        return (
            <Form.Item
                {...{
                    label,
                    labelCol,
                    wrapperCol,
                }}
                className="rac_form_upload"
            >
                {getFieldDecorator(field, {
                    initialValue,
                    rules: [
                        { required, message: `请上传${label}` },
                        {
                            validator: (rule: any, value: any, callback: Function) =>
                                validator ? validator(rule, value, callback) : callback(),
                        },
                    ],
                })(<Input style={{ display: 'none' }} />)}
                {restProps.readOnly ? (
                    restProps.render ? (
                        restProps.render(getFieldValue(field))
                    ) : (
                        <span>{getFieldValue(field)}</span>
                    )
                ) : (
                    <Upload
                        action={action}
                        listType={listType}
                        fileList={
                            getFieldValue(field)
                                ? this.getTypedList(getFieldValue(field))
                                : undefined
                        }
                        onPreview={this.handlePreview}
                        onChange={fileList => {
                            this.handleChange(fileList, fileType, handleChangeCallBack);
                        }}
                        headers={PrototypeCheck.isFunction(headers) ? (headers as any)() : headers}
                        onRemove={this.onRemove}
                        {...(restProps as UploadProps)}
                    >
                        {this.renderUploadComponentByFiletype(
                            fileType,
                            getFieldValue(field)
                                ? this.getTypedList(getFieldValue(field))
                                : undefined,
                            controlNum
                        )}
                    </Upload>
                )}
                {!!progressPercent && (
                    <span className="rac_form_upload_progress">已上传{progressPercent}%</span>
                )}
                {!!customUploadList && customUploadList(getFieldValue(field))}
                <Modal visible={previewVisible} footer={null} onCancel={this.handleCancel}>
                    <img style={{ width: '100%' }} src={previewImage} alt="图片" />
                </Modal>
            </Form.Item>
        );
    }
}

function getBase64(file: any) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });
}

export default FormUpload;
